import axios from 'axios'
import { setupAuthInterceptor } from '../../../../services/config/axios.interceptors'

const BASE_URL = import.meta.env.VITE_URL_SOLUTIONS_API

const api = axios.create({
  baseURL: BASE_URL,
  withCredentials: false
})

// Setup auth interceptor
setupAuthInterceptor(api)

export default api
